import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MapPin, Users, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CommunitiesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/communities`)
      .then((r) => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="container-page py-12 lg:py-20" data-testid="communities-page">
      <div className="overline">Comunidades</div>
      <h1 className="display-heading text-4xl sm:text-5xl lg:text-6xl mt-4">As nossas comunidades.</h1>
      <span className="accent-rule mt-6 block" />
      <p className="mt-6 max-w-2xl text-base text-[hsl(var(--muted-foreground))] leading-relaxed">
        O CIEES Portugal nasce em <strong>Lisboa</strong> e cresce em rede, em comunidades locais
        de empresários e profissionais que vivem a sua fé no quotidiano da empresa. Cada comunidade
        tem a sua equipa, o seu ritmo e os seus encontros — partilhando a mesma missão.
      </p>

      {loading ? (
        <p className="mt-12 text-[hsl(var(--muted-foreground))]">A carregar…</p>
      ) : items.length === 0 ? (
        <div className="mt-12 bg-white border border-[hsl(var(--border))] p-10 text-center" data-testid="communities-empty">
          <MapPin className="h-10 w-10 mx-auto text-[hsl(var(--muted-foreground))]" />
          <p className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">Em breve. As primeiras comunidades estão a ser preparadas.</p>
        </div>
      ) : (
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="communities-list">
          {items.map((c) => (
            <Link key={c.slug} to={`/comunidades/${c.slug}`}
              data-testid={`community-card-${c.slug}`}
              className="group block bg-white border border-[hsl(var(--border))] hover:border-[hsl(var(--accent))] transition-colors">
              <div className="aspect-[16/9] flex items-center justify-center" style={{ backgroundColor: c.accent_color + "18" }}>
                {c.logo_url ? (
                  <img src={c.logo_url} alt={c.name} className="max-h-32 max-w-[60%] object-contain" />
                ) : (
                  <MapPin className="h-14 w-14" style={{ color: c.accent_color }} />
                )}
              </div>
              <div className="p-6">
                <div className="overline" style={{ color: c.accent_color }}>{c.region || "Comunidade local"}</div>
                <h3 className="display-heading text-2xl mt-2 text-[hsl(var(--primary))] group-hover:underline group-hover:underline-offset-4">{c.name}</h3>
                {c.founded_year && (
                  <p className="text-[11px] text-[hsl(var(--muted-foreground))] mt-1">Fundada em {c.founded_year}</p>
                )}
                <p className="mt-4 text-sm text-[hsl(var(--foreground))] line-clamp-3 leading-relaxed">
                  {c.description_pt || "Comunidade local do CIEES Portugal."}
                </p>
                <div className="mt-5 flex items-center justify-between text-[11px] uppercase tracking-[0.16em]">
                  <span className="inline-flex items-center gap-1.5 text-[hsl(var(--muted-foreground))]">
                    <Users className="h-3 w-3" /> {c.member_count} {c.member_count === 1 ? "sócio" : "sócios"}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-[hsl(var(--primary))] group-hover:gap-2.5 transition-all">
                    Conhecer <ArrowRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
